<template>
  <div id="p0435Page">
    <el-row style="top: 5px">
      <!-- 时间 -->
      <el-row style="bottom: 5px">
        <el-col :span="22" :offset="1" style="display: flex;">
          <el-col :span="5" style="display: flex;align-items: center;"
            ><el-col :span="4">{{ $t("p0433.selectTime") }}</el-col
            ><el-col :span="9" :offset="1">
              <!-- 年 -->
              <el-select
                size="small"
                v-model="year"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                @change="yearChange"
              >
                <el-option
                  v-for="item in Object.keys(months)"
                  :key="'year' + item"
                  :label="item"
                  :value="item"
                >
                </el-option> </el-select></el-col
            ><el-col :span="9" :offset="1">
              <!-- 月 -->
              <el-select
                size="small"
                v-model="month"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                @change="monthChange"
              >
                <el-option
                  v-for="item in months[year]"
                  :key="'month' + year + item"
                  :label="item"
                  :value="item"
                >
                </el-option> </el-select></el-col
          ></el-col>
          <el-col
            :span="16"
            style="text-align:center;font-size: 17px;font-weight: 700;color:#333333"
          >
            <!-- 累计培训费用 -->
            <span
              >{{ $t("p0433.cumulativeTrainingCost") + $t("common.colon")
              }}{{
                trainingCostsList[currency]
                  ? trainingCostsList[currency].settled + currency
                  : ""
              }}</span
            >
            <el-select
              v-model="currency"
              class="fixed-select"
              style="width: 100px;"
            >
              <el-option
                v-for="item in Object.keys(trainingCostsList)"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <!-- 待结算培训费用： -->
            <span
              >{{ $t("p0433.unsettledTrainingCost") + $t("common.colon")
              }}{{
                trainingCostsList[currency]
                  ? trainingCostsList[currency].unsettled + currency
                  : ""
              }}</span
            >
          </el-col>
        </el-col>
      </el-row>
      <el-col :span="22" :offset="1">
        <el-table
          :data="TCTable"
          v-loading="pageLoading"
          style="width: 100%; margin-bottom: 75px"
        >
          <!-- 课程编号 -->
          <el-table-column
            prop="title"
            :label="$t('p0433.courseNumber')"
            align="center"
            width="90px"
          >
            <template slot-scope="scope">
              {{
                scope.row.field + scope.row.category + scope.row.courseNumber
              }}
            </template>
          </el-table-column>
          <!-- 课程名称 -->
          <el-table-column
            prop="courseName"
            :label="$t('p0433.courseName')"
            align="left"
            min-width="100"
          >
          </el-table-column>
          <!-- 上课时间 -->
          <el-table-column
            prop="dateAndTime"
            :label="$t('p0433.classTime')"
            align="center"
            width="150px"
          >
          </el-table-column>
          <!-- 培训费用 -->
          <el-table-column
            prop="trainingCosts"
            :label="$t('p0433.trainingCost')"
            align="right"
            min-width="30"
          >
          </el-table-column>
          <!-- 货币 -->
          <el-table-column
            prop="currencyNameZh"
            :label="$t('p0433.currency')"
            align="center"
            width="70px"
          >
          </el-table-column>
          <!-- 状态 -->
          <el-table-column
            prop="status"
            :label="$t('p0433.state')"
            align="center"
            width="90px"
          >
            <template slot-scope="scope">
              <span
                :style="
                  scope.row.status == '1' ? 'color:rgb(8,193,58)' : 'color:red'
                "
              >
                {{ statusFormat(scope.row.status) }}
              </span></template
            >
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            width="170px"
          >
            <template slot-scope="scope">
              <div class="blueDivider">
                <!-- 满意度调查 -->
                <el-button type="text" @click="handleSurveyLink(scope.row)">{{
                  $t("p0433.satisfactionSurvey")
                }}</el-button>
                <!-- 支付 -->
                <el-button
                  v-if="scope.row.status !== 1"
                  type="text"
                  @click="handlePay(scope.row)"
                  >{{ $t("支付") }}</el-button
                >
                <!-- 支付明细 -->
                <el-button
                  v-if="scope.row.status === 1"
                  type="text"
                  @click="handlePayEdit(scope.row)"
                  >{{ $t("p0433.paymentDetails") }}</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row><br /><br /></el-row>
    <!-- 满意度调查 -->
    <el-dialog
      :title="$t('p0433.satisfactionSurvey')"
      :visible.sync="surveyLinkV"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="750px"
      class="el-dialog__body"
    >
      <el-form
        class="systemFont1"
        :model="surveyLinkForm"
        label-width="150px"
        style="width:90%;"
        ref="surveyLinkFormRef"
        hide-required-asterisk
        label-position="right"
      >
        <el-row>
          <!-- 满意度调查链接 -->
          <el-col :span="21">
            <el-form-item
              :label="$t('p0433.satisfactionSurveyLink')"
              prop="surveyLink"
              :rules="surveyLink"
            >
              <el-input
                v-model="surveyLinkForm.surveyLink"
                maxlength="500"
                spellcheck="false"
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" :offset="1">
            <!-- 查看 -->
            <el-form-item label-width="0px">
              <el-button
                type="text"
                size="big"
                @click.native="openSurveyLink"
                >{{ $t("p0433.view") }}</el-button
              ></el-form-item
            >
          </el-col>
        </el-row>
        <div style="text-align: center;margin-bottom:20px">
          <!-- 提交 -->
          <el-button
            type="p0402create"
            size="big"
            @click.native="submitSurvey"
            >{{ $t("common.submit") }}</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- 支付凭证 -->
    <el-dialog
      :title="$t('p0433.proofOfPayment')"
      :visible.sync="payV"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="750px"
      class="el-dialog__body"
    >
      <el-form
        class="systemFont1"
        :model="payForm"
        label-width="150px"
        style="width:90%;"
        ref="payFormRef"
        hide-required-asterisk
        label-position="right"
      >
        <el-row>
          <!-- 选择支付时间 -->
          <el-form-item
            :label="$t('p0433.selectPaymentTime')"
            prop="paymentTime"
            :rules="paymentTime"
          >
            <el-date-picker
              v-model="payForm.paymentTime"
              type="datetime"
              size="small"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 上传支付凭证 -->
          <el-form-item
            :label="$t('p0433.uploadPayProof')"
            prop="locationCode"
            :rules="locationCode"
          >
            <uploadFile
              :key="uploadFileKey"
              ref="locationCodeRef"
              :uploadButtonStyle="2"
              :uploadFile="{
                locationCode: payForm.locationCode,
                uploadBtnDisplayFlag: true
              }"
              :uploadDisable="false"
            >
            </uploadFile>
          </el-form-item>
        </el-row>
      </el-form>
      <div style="text-align: center;margin-bottom:20px">
        <!-- 提交按钮 -->
        <el-button type="p0402create" size="big" @click.native="submitPay">{{
          $t("common.submit")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 支付明细 -->
    <el-dialog
      :title="$t('p0433.paymentDetails')"
      :visible.sync="payEditV"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="750px"
      class="el-dialog__body"
    >
      <el-form
        class="systemFont1"
        :model="payForm"
        label-width="150px"
        style="width:90%;"
        ref="payFormRef1"
        hide-required-asterisk
        label-position="right"
      >
        <el-row>
          <!-- 支付时间 -->
          <el-form-item
            :label="$t('p0433.paymentTime')"
            prop="paymentTime"
            :rules="paymentTime"
          >
            <span style="color:#606266;font-weight: initial;">{{
              payForm.paymentTime
            }}</span>
          </el-form-item>
          <!-- 上传支付凭证 -->
          <el-form-item
            :label="$t('p0433.proofOfPayment')"
            prop="locationCode"
            :rules="locationCode"
          >
            <uploadFile
              :key="uploadFileKey1"
              ref="locationCodeRef1"
              :uploadButtonStyle="2"
              :uploadPreview="true"
              :uploadFile="{
                locationCode: payForm.locationCode,
                uploadBtnDisplayFlag: false
              }"
              :uploadDisable="true"
            >
            </uploadFile>
          </el-form-item>
        </el-row>
      </el-form>
      <div style="text-align: center;margin-bottom:20px"></div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import uploadFile from "../../../components/Common/UploadAttachment.vue";
import { build20Id } from "../../../utils/buildId";
export default {
  components: {
    uploadFile
  },
  props: {
    userId: {
      type: Number, // 根据实际情况设置类型
      required: true // 根据实际情况设置是否必需
    },
    teacherClassWatch: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    async teacherClassWatch(newValue, oldValue) {
      // 执行初始化操作
      this.surveyLinkForm.userId = this.userId;
      this.payForm.userId = this.userId;
      this.year = this.currentYear.toString();
      this.month = this.currentMonth;
      await this.selectTeacherClassDateApi();
      await this.init();
      this.currency = Object.keys(this.trainingCostsList)[0];
    },
    month(newValue, oldValue) {
      this.init();
    }
  },
  data() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // JavaScript中的月份是从0开始的，所以需要加1
    const userId = this.$options.propsData.userId;
    return {
      year: currentYear.toString(),
      currentYear: currentYear,
      month: currentMonth,
      currentMonth: currentMonth,
      years: [],
      months: {},
      pickerOptions: {
        disabledDate(time) {
          // 获取当前时间
          const currentTime = new Date();
          // 如果选中的时间大于当前时间，则禁用该时间
          return time.getTime() > currentTime.getTime();
        }
      },
      trainingCostsList: [],
      currency: null,
      // 页面载入状态
      pageLoading: false,
      // 页面数据
      TCTable: [],
      // 对话框隐藏状态
      surveyLinkV: false,
      payV: false,
      payEditV: false,
      uploadFileKey: build20Id(),
      uploadFileKey1: build20Id(),
      surveyLinkForm: {
        updateUser: localStorage.getItem("userId"),
        userId: userId,
        surveyLink: "",
        field: "",
        category: "",
        courseNumber: "",
        dateAndTime: null
      },
      payForm: {
        updateUser: localStorage.getItem("userId"),
        userId: userId,
        field: "",
        category: "",
        courseNumber: "",
        dateAndTime: null,
        paymentTime: null,
        locationCode: build20Id()
      },
      courseName: [
        {
          required: true,
          message: this.$t("p0412.enterNumber"),
          trigger: "blur"
        }
      ],
      surveyLink: [
        {
          required: true,
          // 请输入链接
          message: this.$t("p0433.enterLink"),
          trigger: "blur"
        },
        {
          pattern: /^(http|https):\/\/([\w-]+\.)+[\w-]+(\/[\w-./#?%&=]*)?$/,
          message: this.$t("schedulingAndPricing.linkFormatIsIncorrect"),
          trigger: "blur"
        }
      ],
      paymentTime: [
        {
          required: true,
          message: this.$t("请输入支付时间"),
          trigger: "blur"
        }
      ],
      locationCode: [
        {
          required: true,
          //
          message: this.$t("p0433.enterPaymentTime"),
          trigger: "blur"
        }
      ]
    };
  },
  async mounted() {
    await this.selectTeacherClassDateApi();
    await this.init();
  },
  methods: {
    // 初始化
    async init() {
      this.TCTable = [];
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#p0435Page")
      });
      let url = "/api/TrainerManagement/selectTeacherClassList";
      await this.$http
        .post(url, {
          userId: this.userId,
          year: this.year,
          month: this.month
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data.teacherClassVos == null) {
              this.TCTable = [];
              this.trainingCostsList = [];
              this.currency = 0;
            } else {
              // 渲染页面
              this.TCTable = response.data.data.teacherClassVos;
              this.trainingCostsList = response.data.data.trainingCostsList;
              if (this.isStringNull(this.currency)) {
                this.currency = Object.keys(this.trainingCostsList)[0];
              }
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取时间筛选
    async selectTeacherClassDateApi() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#p0435Page")
      });
      let url = "/api/TrainerManagement/selectTeacherClassDate";
      await this.$http
        .post(url, {
          userId: this.userId
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.years = [];
              this.months = [];
            } else {
              // 渲染页面
              this.years = response.data.data.years;
              this.months = response.data.data.months;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    //打开满意度调查链接弹窗
    handleSurveyLink(row) {
      if (this.$refs.surveyLinkFormRef) {
        // 清空所有值
        this.$refs.surveyLinkFormRef.clearValidate();
        // 清空所有验证
        this.$refs.surveyLinkFormRef.resetFields();
      }
      this.surveyLinkForm.surveyLink = row.surveyLink;
      this.surveyLinkForm.field = row.field;
      this.surveyLinkForm.category = row.category;
      this.surveyLinkForm.courseNumber = row.courseNumber;
      this.surveyLinkForm.dateAndTime = row.dateAndTime;
      this.surveyLinkV = true;
    },
    // 查看按钮满意度调查链接
    openSurveyLink() {
      this.$refs["surveyLinkFormRef"].validate(valid => {
        if (valid) {
          window.open(this.surveyLinkForm.surveyLink, "_blank");
        }
      });
    },
    // 提交满意度链接
    submitSurvey() {
      this.$refs["surveyLinkFormRef"].validate(valid => {
        if (valid) {
          this.surveyLinkV = false;
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#p0435Page")
          });
          let url = "/api/TrainerManagement/updateSurveyLink";
          this.$http
            .post(url, this.surveyLinkForm)
            .then(async response => {
              loading.close();
              if (response.data.code === 200) {
                await this.init();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              console.log(err);
              loading.close();
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 打开支付凭证弹窗
    handlePay(row) {
      if (this.$refs.payFormRef) {
        // 清空所有值
        this.$refs.payFormRef.clearValidate();
        // 清空所有验证
        this.$refs.payFormRef.resetFields();
      }
      this.payForm.locationCode = build20Id();
      this.payForm.paymentTime = row.paymentTime;
      this.payForm.field = row.field;
      this.payForm.category = row.category;
      this.payForm.courseNumber = row.courseNumber;
      this.payForm.dateAndTime = row.dateAndTime;
      this.payForm.currencyType = row.currencyType;
      this.payForm.trainingCosts = row.trainingCosts;
      this.uploadFileKey = build20Id();
      this.payV = true;
    },
    // 提交支付凭证
    submitPay() {
      this.$refs["payFormRef"].validate(valid => {
        if (valid) {
          this.payV = false;
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#p0435Page")
          });
          this.payForm.paymentTime = moment(this.payForm.paymentTime).format(
            "YYYY-MM-DD HH:mm"
          );
          let url = "/api/TrainerManagement/updateProofOfPayment";
          this.$http
            .post(url, this.payForm)
            .then(async response => {
              loading.close();
              if (response.data.code === 200) {
                await this.$refs.locationCodeRef.submitUploadFile();
                await this.init();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              console.log(err);
              loading.close();
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 打开支付凭证显示弹窗
    handlePayEdit(row) {
      if (this.$refs.payFormRef1) {
        // 清空所有值
        this.$refs.payFormRef1.clearValidate();
        // 清空所有验证
        this.$refs.payFormRef1.resetFields();
      }
      this.payForm.locationCode = row.locationCode;
      this.payForm.paymentTime = row.paymentTime;
      this.uploadFileKey1 = build20Id();
      this.payEditV = true;
    },
    // 时间修改
    monthChange() {
      console.log(this.month);
      this.init();
    },
    yearChange() {
      this.month = this.months[this.year][0];
      console.log(this.year);
    },
    // 状态修改
    statusFormat(value) {
      return value == "1"
        ? this.$t("p0433.settled")
        : this.$t("p0433.unsettled");
    },
    // String 为空 true ： false
    isStringNull(val) {
      if (val == null || val == "" || typeof val == "undefined") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.blueDivider {
  display: inline-block;
}

.blueDivider >>> .el-divider--vertical {
  background-color: #00b0f0;
}

.foot-container {
  margin: 100px auto 0 auto;
  height: 26px;
  width: 50%;
  text-align: center;
}

/* p0402 */
/* email群模板 */
.el-button--p0402create:focus,
.el-button--p0402create {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 24px;
}

.el-button--p0402save:focus,
.el-button--p0402save {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 130px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 24px;
}

/* 返回 */
.el-button--p0402return {
  /* 999999 */
  background-color: #ffffff;
  /* 999999 */
  border-color: #d9d9d9;
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0;
  font-family: "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #000000;
  font-size: 13px;
  line-height: 18px;
}

.el-button--p0402add:focus,
.el-button--p0402add {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 14px;
  line-height: 24px;
  border-radius: 6px;
}

>>> .el-dialog__body {
  padding-top: 10px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  padding: 3px 30px;
  overflow-y: auto;
}
// 下拉框边框和背景颜色
.fixed-select >>> .el-input--suffix .el-input__inner {
  color: #333333;
  border: none;
  background-color: transparent;
  font-size: 17px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/MarketingMgt/P0435.vue